import React from "react";
import {
  CountryProfileInfo,
  CountryProfileInfoType,
  ITermsAndCondition,
} from "./CountriesProfile.type";

export const CountryProfileContext =
  React.createContext<CountryProfileInfoType | null>(null);

export const intialCountryProfileInfo = {
  countryName: "",
  twoDigitCountryCode: "",
  currencyCode: "",
  countryDigitCode: "",
  languageCode: "",
  region: "",
  countryCode: "",
  warehouseCountry: "",
  warehouseCity: "",
  warehouseState: "",
  warehouseStreet: "",
  warehouseZipCode: "",
  administrativeOriginName: "",
  administrativeOriginState: "",
  administrativeOriginCountry: "",
  administrativeOriginCity: "",
  administrativeOriginStreet: "",
  administrativeOriginZipCode: "",
  partitionKey: "",
  id: "",
  companyCode: "",
  eTag: "",
  isActive: "",
  createdBy: "",
  bankName: "",
  bankKey: "",
  bankPhone: "",
  bankAddress: "",
  addressLine1:"",
  addressLine2:"",
  addressLine3:"",
  bankCompanyCode: "", 
  bsbCode: "", 
  abn:"",
  accountName: "",
  accountAddress: "",
  accountNumber: "",
  iban: "",
  swiftCode: "",
  switchCode:"",
  swiftBicCode:"",
  vatId: "",
  bcCode: "",
  taxId: "",
  sortCode: "",
  correspondingBank: "",
  correspondingBankSwiftBICCode: "",
  createdAt: "",
  updatedAt: "",
  termsAndConditions: [] as ITermsAndCondition[],
  currency: "",
  updatedBy: "",
  remittanceCompanyCode: "",
  remittanceCurrencyCode: "",
};

const CountryProfileProvider: React.FC<React.ReactNode> = ({ children }) => {
  const [countryProfileInfo, setCountryProfileInfoData] =
    React.useState<CountryProfileInfo>(intialCountryProfileInfo);

  const setCountryProfileInfo = (countryProfileInfos: CountryProfileInfo) => {
    setCountryProfileInfoData({
      ...countryProfileInfo,
      countryName: countryProfileInfos.countryName,
      twoDigitCountryCode: countryProfileInfos.twoDigitCountryCode,
      currencyCode: countryProfileInfos.currencyCode,
      countryDigitCode: countryProfileInfos.countryDigitCode,
      languageCode: countryProfileInfos.languageCode,
      region: countryProfileInfos.region,
      countryCode: countryProfileInfos.countryCode,
      warehouseCountry: countryProfileInfos.warehouseCountry,
      warehouseCity: countryProfileInfos.warehouseCity,
      warehouseState: countryProfileInfos.warehouseState,
      warehouseStreet: countryProfileInfos.warehouseStreet,
      warehouseZipCode: countryProfileInfos.warehouseZipCode,
      administrativeOriginName: countryProfileInfos.administrativeOriginName,
      administrativeOriginState: countryProfileInfos.administrativeOriginState,
      administrativeOriginCountry:
        countryProfileInfos.administrativeOriginCountry,
      administrativeOriginCity: countryProfileInfos.administrativeOriginCity,
      administrativeOriginStreet:
        countryProfileInfos.administrativeOriginStreet,
      administrativeOriginZipCode:
        countryProfileInfos.administrativeOriginZipCode,
      partitionKey: countryProfileInfos.partitionKey,
      id: countryProfileInfos.id,
      companyCode: countryProfileInfos.companyCode,
      eTag: countryProfileInfos.eTag,
      createdBy: countryProfileInfos.createdBy,
      vatId: countryProfileInfos.vatId,
      isActive: countryProfileInfos.isActive,
      bankName: countryProfileInfos.bankName,
      bankAddress: countryProfileInfos.bankAddress,
      addressLine1:countryProfileInfos.addressLine1,
      addressLine2:countryProfileInfos.addressLine2,
      addressLine3:countryProfileInfos.addressLine3,
      accountName: countryProfileInfos.accountName,
      accountNumber: countryProfileInfos.accountNumber,
      iban: countryProfileInfos.iban,
      swiftCode: countryProfileInfos.swiftCode,
      switchCode:countryProfileInfos.switchCode,
      swiftBicCode:countryProfileInfos.swiftBicCode,
      correspondingBank: countryProfileInfos.correspondingBank,
      createdAt: countryProfileInfos.createdAt,
      updatedAt: countryProfileInfos.updatedAt,
      termsAndConditions:countryProfileInfos.termsAndConditions,
      correspondingBankSwiftBICCode:
        countryProfileInfos.correspondingBankSwiftBICCode,
      sortCode: countryProfileInfos.sortCode,
      bankCompanyCode: countryProfileInfos.bankCompanyCode,
      bcCode: countryProfileInfos.bcCode,
      bsbCode: countryProfileInfos.bsbCode,
      abn: countryProfileInfos.abn,
      bankKey: countryProfileInfos.bankKey,
      accountAddress: countryProfileInfos.accountAddress,
      bankPhone: countryProfileInfos.bankPhone,
      taxId: countryProfileInfos.taxId,
      currency: countryProfileInfos.currency,
      updatedBy: countryProfileInfos.updatedBy,
      remittanceCompanyCode: countryProfileInfos.remittanceCompanyCode,
      remittanceCurrencyCode: countryProfileInfos.remittanceCurrencyCode,
    } as CountryProfileInfo);
  };

  return (
    <CountryProfileContext.Provider
      value={{ countryProfileInfo, setCountryProfileInfo }}
    >
      {children}
    </CountryProfileContext.Provider>
  );
};

export default CountryProfileProvider;
